import { render, staticRenderFns } from "./divisi.vue?vue&type=template&id=841adeec"
import script from "./divisi.vue?vue&type=script&lang=js"
export * from "./divisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports